import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
export default function Footnotes() {
  const $ = _c(2);
  const {
    footnotes
  } = useReviewContext();
  if (!footnotes) {
    return null;
  }
  let t0;
  if ($[0] !== footnotes) {
    t0 = <Box display="flex" gap={2} flexDirection="column" my={3}><StructuredContentRenderer doc={footnotes} /></Box>;
    $[0] = footnotes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}